import apiMeterClient from './apiMeterClient'

const END_POINT = '/meters'

const get = (meter) => 
    apiMeterClient.get( `${END_POINT}/${meter.id}?key=${meter.key}` )

const control = (meter, status) => 
    apiMeterClient.post( `${END_POINT}/control/${meter}`, {
        fotocelda: status.fotocelda,
        control: status.control
    })

const schedule = (meter, payload) => 
    apiMeterClient.post( `${END_POINT}/schedule/control/${meter}`, payload)

const suntime = (meter, payload) => 
    apiMeterClient.post( `${END_POINT}/suntime/${meter}`, payload)

const Meter = { get, control, schedule, suntime }

export default Meter